import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

/**
 *  WIFI ESZKÖZÖK (MAC-engedélyezőlista) – admin.
 *
 *  A hálózati eszköz ebből a listából engedi a gépeket a wifire, VLAN szerint.
 *  Itt lehet elbírálni a felhasználói bejelentéseket (akár tömegesen), és kézzel
 *  felvenni azt, amihez nincs kérelmező (nyomtató, projektor).
 */
@Component({
  selector: 'app-mac-allowlist',
  templateUrl: './mac-allowlist.component.html',
  styleUrls: ['./mac-allowlist.component.scss'],
})
export class MacAllowlistComponent implements OnInit {
  intezmenyId = '';
  felhasznalo = '';
  toltodik = false;

  eszkozok: any[] = [];
  osszesites: any = {};
  vlanSzabaly: any = {};

  szuroStatusz = 'kerelem';        // a kérelmekkel kezdünk: az a teendő
  kereses = '';
  kijelolt: number[] = [];
  elutasitasIndok = '';

  uj: any = { mac: '', device_name: '', vlan_id: 20, megjegyzes: '', igenylo: '', igenylo_mod: '' };
  ujNyitva = false;

  /*  FELHASZNÁLÓHOZ RENDELÉS.
   *
   *  Aki maga küldi be az eszközt, ahhoz hozzá van rendelve – az adminban kézzel
   *  felvett gépnél viszont eddig nem lehetett gazdát megadni, és a meglévőt sem
   *  lehetett átírni. Így a listán ott álltak eszközök, amikről nem lehetett
   *  megmondani, kihez tartoznak.
   */
  szemelyek: any[] = [];
  szemelySzuro = '';
  /** Melyik sor hozzárendelését szerkesztjük épp (id), vagy 'uj' a felvételi űrlapon. */
  hozzarendelesSor: any = null;

  get szurtSzemelyek(): any[] {
    const k = this.szemelySzuro.trim().toLowerCase();
    return (this.szemelyek || [])
      .filter((sz) => !k
        || String(sz.nev || '').toLowerCase().includes(k)
        || String(sz.azonosito || '').toLowerCase().includes(k))
      .slice(0, 200);
  }

  async szemelyekBetolt() {
    if (this.szemelyek.length) return;
    try {
      this.szemelyek = await firstValueFrom(
        this.http.get<any[]>(`/api/mac-allowlist/szemelyek/${this.intezmenyId}`)) || [];
    } catch (e) { this.szemelyek = []; }
  }

  /** A választó megnyitása egy sorhoz (vagy a felvételi űrlaphoz: 'uj'). */
  async hozzarendelesNyit(mihez: any) {
    this.hozzarendelesSor = this.hozzarendelesSor === mihez ? null : mihez;
    this.szemelySzuro = '';
    if (this.hozzarendelesSor) await this.szemelyekBetolt();
  }

  async szemelytValaszt(sz: any) {
    if (this.hozzarendelesSor === 'uj') {
      this.uj.igenylo = sz.azonosito;
      this.uj.igenylo_nev = sz.nev;
      this.uj.igenylo_mod = sz.tipus;
      this.hozzarendelesSor = null;
      return;
    }
    const e = this.hozzarendelesSor;
    try {
      await firstValueFrom(this.http.put(`/api/mac-allowlist/${e.id}`,
        { igenylo: sz.azonosito, igenylo_mod: sz.tipus }));
      e.igenylo = sz.azonosito; e.igenylo_nev = sz.nev; e.igenylo_mod = sz.tipus;
      this.hozzarendelesSor = null;
      this.data.sendToast(`Hozzárendelve: ${sz.nev}`, 'success');
    } catch (err: any) {
      this.data.sendToast(err?.error?.error || 'A hozzárendelés nem sikerült.', 'error');
    }
  }

  async hozzarendelesTorol(e: any) {
    if (!confirm('Megszünteted a hozzárendelést? Az eszköz gazda nélkül marad.')) return;
    try {
      await firstValueFrom(this.http.put(`/api/mac-allowlist/${e.id}`,
        { igenylo: '', igenylo_mod: '' }));
      e.igenylo = null; e.igenylo_nev = null; e.igenylo_mod = null;
      this.hozzarendelesSor = null;
    } catch (err: any) {
      this.data.sendToast(err?.error?.error || 'A művelet nem sikerült.', 'error');
    }
  }

  /*  A mód a VLAN-t is meghatározza, de NEM írjuk át magától: a kettő
   *  szándékosan eltérhet. Ha eltér, jelezzük – így nem marad észrevétlen. */
  vlanElter(e: any): boolean {
    const vart = this.vlanSzabaly?.[e?.igenylo_mod];
    return !!vart && !!e?.vlan_id && Number(vart) !== Number(e.vlan_id);
  }

  tipusNev(t: string): string { return t === 'tanulo' ? 'tanuló' : 'dolgozó'; }

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    this.intezmenyId = (await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId;
    this.felhasznalo = (await this.data.getFromStorage('userMetadata'))?.username || '';
    await this.betolt();
  }

  async betolt() {
    this.toltodik = true;
    try {
      const p = new URLSearchParams();
      if (this.szuroStatusz) p.set('statusz', this.szuroStatusz);
      if (this.kereses.trim()) p.set('kereses', this.kereses.trim());
      const r: any = await firstValueFrom(
        this.http.get(`/api/mac-allowlist/lista/${this.intezmenyId}?${p.toString()}`));
      this.eszkozok = r?.eszkozok || [];
      this.osszesites = r?.osszesites || {};
      this.vlanSzabaly = r?.vlan_szabaly || {};
      this.kijelolt = [];
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A lista betöltése nem sikerült.', 'error');
    } finally {
      this.toltodik = false;
    }
  }

  szuroValt(statusz: string) { this.szuroStatusz = statusz; this.betolt(); }

  /* ── kijelölés ── */

  kijelolve(id: number) { return this.kijelolt.includes(id); }

  kijelolValt(id: number, be: boolean) {
    this.kijelolt = be
      ? [...new Set([...this.kijelolt, id])]
      : this.kijelolt.filter((x) => x !== id);
  }

  mindKijelol(be: boolean) {
    this.kijelolt = be ? this.eszkozok.map((e) => e.id) : [];
  }

  get mindKijelolve(): boolean {
    return !!this.eszkozok.length && this.kijelolt.length === this.eszkozok.length;
  }

  /* ── elbírálás ── */

  async dontes(dontes: 'jovahagy' | 'elutasit') {
    if (!this.kijelolt.length) { this.data.sendToast('Nincs kijelölt eszköz.', 'warning'); return; }
    if (dontes === 'elutasit' && !this.elutasitasIndok.trim()
      && !confirm('Indoklás nélkül utasítod el? A felhasználó nem fogja tudni, miért.')) return;
    try {
      const r: any = await firstValueFrom(this.http.post('/api/mac-allowlist/dontes', {
        ids: this.kijelolt, dontes,
        indok: dontes === 'elutasit' ? this.elutasitasIndok.trim() : null,
        felhasznalo: this.felhasznalo,
      }));
      this.data.sendToast(`${r?.db || 0} eszköz ${dontes === 'jovahagy' ? 'jóváhagyva' : 'elutasítva'}.`, 'success');
      this.elutasitasIndok = '';
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A döntés mentése nem sikerült.', 'error');
    }
  }

  /* ── karbantartás ── */

  async engedelyValt(e: any) {
    try {
      await firstValueFrom(this.http.put(`/api/mac-allowlist/${e.id}`, { enabled: !e.enabled }));
      e.enabled = e.enabled ? 0 : 1;
    } catch (err: any) {
      this.data.sendToast(err?.error?.error || 'A módosítás nem sikerült.', 'error');
    }
  }

  async vlanValt(e: any, vlan: any) {
    try {
      await firstValueFrom(this.http.put(`/api/mac-allowlist/${e.id}`, { vlan_id: vlan }));
      e.vlan_id = vlan ? Number(vlan) : null;
      this.data.sendToast('VLAN módosítva.', 'success');
    } catch (err: any) {
      this.data.sendToast(err?.error?.error || 'A módosítás nem sikerült.', 'error');
    }
  }

  async torles(e: any) {
    if (!confirm(`Törlöd? ${e.mac_formazott} – ${e.device_name || 'névtelen eszköz'}`)) return;
    try {
      await firstValueFrom(this.http.delete(`/api/mac-allowlist/${e.id}`));
      await this.betolt();
    } catch (err: any) {
      this.data.sendToast(err?.error?.error || 'A törlés nem sikerült.', 'error');
    }
  }

  async ujFelvetel() {
    if (!this.uj.mac?.trim()) { this.data.sendToast('Add meg a MAC-címet.', 'warning'); return; }
    try {
      await firstValueFrom(this.http.post(`/api/mac-allowlist/${this.intezmenyId}`, {
        ...this.uj, felhasznalo: this.felhasznalo,
      }));
      this.data.sendToast('Eszköz felvéve.', 'success');
      this.uj = { mac: '', device_name: '', vlan_id: 20, megjegyzes: '', igenylo: '', igenylo_mod: '' };
      this.ujNyitva = false;
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A felvétel nem sikerült.', 'error');
    }
  }

  allapotSzin(statusz: string) {
    return { kerelem: 'warning', jovahagyva: 'success', elutasitva: 'danger' }[statusz] || 'medium';
  }
  allapotNev(statusz: string) {
    return { kerelem: 'elbírálásra vár', jovahagyva: 'jóváhagyva', elutasitva: 'elutasítva' }[statusz] || statusz;
  }
}
